<template>
  <div v-if="!showLoader" class="myhome-user-data">
    <div class="myhome-user-data__right">
      <DataField
        :field="user.firstname"
        :link-color="linkColor"
        :show-link="true"
        title="nome"
        @open-modify="
          nameType = 'firstname';
          openModal('NameModal');
        "
      />
      <DataField
        v-if="!isChildren || modifyLastName"
        :field="user.lastname"
        :link-color="linkColor"
        :show-link="modifyLastName"
        title="cognome"
        @open-modify="
          nameType = 'lastname';
          openModal('NameModal');
        "
      />
      <DataField
        v-if="!isChildren"
        :field="user.phone"
        :link-color="linkColor"
        placeholder="Aggiungi il tuo numero di telefono"
        :show-link="true"
        title="telefono"
        @open-modify="openModal('PhoneModal')"
      />
      <DataField
        v-if="isChildren"
        :field="passwordField"
        :link-color="linkColor"
        :show-link="true"
        title="PASSWORD"
        @open-modify="openModal('PasswordModal')"
      />
      <DataField
        :field="birthDate"
        :link-color="linkColor"
        placeholder="Aggiungi la tua data di nascita"
        :show-link="true"
        title="data di nascita"
        @open-modify="openModal('DateModal')"
      />
      <DataField
        v-if="!isChildren"
        :field="user.cf"
        :link-color="linkColor"
        placeholder="Aggiungi il tuo codice fiscale"
        :show-link="true"
        title="codice fiscale"
        @open-modify="openModal('FiscalCodeModal')"
      />
      <EmailField
        :is-children="isChildren"
        :mails-list="user.emails"
        :link-color="linkColor"
        title="EMAIL"
        @open-modify="openModal('EmailModal', $event)"
      />
      <EmailVerifyField
        v-if="user.emails_unverified.length"
        :is-children="isChildren"
        :mails-list="user.emails_unverified"
        :link-color="linkColor"
        title="Email da verificare"
        @email-verify="sendConfirmationEmail"
        @email-delete="deleteEmail"
      />
      <DataField
        v-if="user.teacher || user.principal"
        :field="user.miur_email"
        :link-color="linkColor"
        :placeholder="miurEmailPlaceholder()"
        placeholder-class="dea-heading--regular-s"
        :show-link="true"
        :show-remove-email="true"
        title="EMAIL MINISTERIALE"
        @open-modify="openModal('EmailModal', $event, true)"
      />
      <DataField
        v-if="!isChildren"
        :field="passwordField"
        :link-color="linkColor"
        :show-link="true"
        title="PASSWORD"
        @open-modify="openModal('PasswordModal')"
      />
      <DataField
        v-if="user.generic"
        :field="user.school_roles"
        :link-color="linkColor"
        placeholder="Aggiungi il tuo ruolo"
        :show-link="true"
        title="RUOLO"
        @open-modify="openModal('RoleModal')"
      />
      <DataField
        v-if="user.generic"
        :field="otherSchool"
        :link-color="linkColor"
        placeholder="Aggiungi la tua scuola"
        :show-link="true"
        title="SCUOLA"
        @open-modify="openModal('SchoolModal')"
      />
    </div>
    <div class="myhome-user-data__left">
      <div class="myhome-user-data__left-avatar">
        <ChangeAvatar :link-color="linkColor" :src="avatarIcon" @click="openModal('AvatarModal')" />
      </div>
      <div v-if="!isChildren" class="myhome-user-data__left-phrase">
        <div class="myhome-user-data__left-phrase-title dea-heading--medium-xs">
          COME RIFERIRSI A ME:
        </div>
        <div class="myhome-user-data__left-phrase-label">
          <div v-if="user.gender" class="dea-heading--medium-xs">
            {{ getRefer() }}
          </div>
          <div v-else class="dea-heading--regular-m">
            Seleziona una frase.
          </div>
        </div>
        <div class="myhome-user-data__left-phrase-link">
          <Links
            class="data-field__content-link dea-links--large dea-links--pointer"
            :class="`dea-links--${linkColor}`"
            @click="openModal('ReferModal')"
          >
            Scegli come dobbiamo riferici a te.
          </Links>
        </div>
      </div>
      <div v-else class="myhome-user-data__left-phrase-link">
        <Links
          class="data-field__content-link data-field__content-link-delete dea-links--large dea-links--pointer"
          :class="`dea-links--${linkColor}`"
          @click="openModal('DeleteUserModal')"
        >
          Elimina profilo studente
        </Links>
      </div>
    </div>
    <component
      :is="componentId"
      v-if="modalVisible && !showLoader"
      :email-mode="emailMode"
      :email-target="emailTarget"
      :is-miur-email="isMiurEmail"
      :name-type="nameType"
      :user="user"
      :visible="modalVisible"
      @delete-user="deleteUser"
      @email-delete="deleteEmail"
      @email-update="changeEmail"
      @confirm-email="updateEmail"
      @modal-close="modalVisible = false"
      @user-update="updateUser"
    />
  </div>
  <Loader v-else />
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions } from "vuex";
import ChangeAvatar from "@/components/patterns/ChangeAvatar";
import handleWindowResize from "@/components/mixins/handleWindowResize";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";
import variables from "@/styles/variables.scss";
import AvatarModal from "~/components/myProfile/modals/AvatarModal";
import DateModal from "~/components/myProfile/modals/DateModal";
import DeleteUserModal from "~/components/myProfile/modals/DeleteUserModal";
import EmailModal from "~/components/myProfile/modals/EmailModal";
import EmailConfirmationModal from "~/components/myProfile/modals/EmailConfirmationModal";
import FiscalCodeModal from "~/components/myProfile/modals/FiscalCodeModal";
import NameModal from "~/components/myProfile/modals/NameModal";
import PasswordModal from "~/components/myProfile/modals/PasswordModal";
import PhoneModal from "~/components/myProfile/modals/PhoneModal";
import ReferModal from "~/components/myProfile/modals/ReferModal";
import RoleModal from "~/components/myProfile/modals/RoleModal";
import SchoolModal from "~/components/myProfile/modals/SchoolModal";
import DataField from "./DataField";
import EmailField from "./EmailField";
import EmailVerifyField from "./EmailVerifyField";
import getBirthDate from "../helpers/getBirthDate";
import referSentences from "../helpers/referSentences";
import User from "../../../clients/user";

export default {
  name: "UserData",
  components: {
    AvatarModal,
    ChangeAvatar,
    DataField,
    DateModal,
    DeleteUserModal,
    EmailField,
    EmailModal,
    EmailConfirmationModal,
    EmailVerifyField,
    FiscalCodeModal,
    Links,
    Loader,
    NameModal,
    PasswordModal,
    PhoneModal,
    ReferModal,
    RoleModal,
    SchoolModal,
  },
  mixins: [handleWindowResize],
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    modifyLastName: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      componentId: "DateModal",
      emailMode: "",
      emailTarget: "",
      isMiurEmail: false,
      loaderVisible: false,
      modalVisible: false,
      nameType: "firstname",
      referSentences,
    };
  },
  computed: {
    avatarIcon() {
      const dashIndex = this.user.role.indexOf("_");
      const roleOrig = this.user.role.substring(dashIndex + 1);
      const role = roleOrig === "PARENT" ? "family" : roleOrig.toLowerCase();
      if (this.user.avatar) {
        return `${this.$root.config.avatarsURL}/${role}/${this.user.avatar}.svg`;
      }
      if (this.user.avatar_icon) {
        return this.user.avatar_icon;
      }
      return `${this.$root.config.avatarsURL}/${role}/1.svg`;
    },
    birthDate() {
      if (this.user.birth_day && this.user.birth_month && this.user.birth_year) {
        const { day, month, year } = this.getBirthDate(
          this.user.birth_day,
          this.user.birth_month,
          this.user.birth_year
        );
        return `${day}/${month}/${year}`;
      }
      return "";
    },
    isChildren() {
      return Boolean(this.user.parent_id);
    },
    otherSchool() {
      if (this.user.other_school_address && this.user.other_school_name) {
        return `${this.user.other_school_name}<br>${this.user.other_school_address}`;
      }
      return null;
    },
    passwordField() {
      return "********";
    },
    showLoader() {
      return (
        this.loaderVisible && this.windowWidth <= variables.bpSizeMedium && document.body.classList.contains("wait")
      );
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async changeEmail(email, isMiurEmail) {
      if (isMiurEmail) {
        await this.updateUser({ miur_email: email });
      } else if (this.emailMode === "save") {
        this.componentId = "EmailConfirmationModal";
        this.emailTarget = email;
        this.modalVisible = true;
      } else {
        this.updateEmail(email);
      }
    },
    async deleteEmail(email) {
      if (email) this.emailTarget = email;
      if (this.isMiurEmail) {
        await this.updateUser({ miur_email: null });
      } else {
        document.querySelector("body").classList.add("wait");
        this.loaderVisible = true;
        try {
          const payload = {
            body: {
              email: this.emailTarget,
            },
            type: "remove_email",
          };
          await User.modifyUserEmail(this.$root.config, this.user.id, payload);
          await this.fetchUser(true);
          document.querySelector("body").classList.remove("wait");
        } catch (e) {
          Sentry.captureException(e);
        }
        this.modalVisible = false;
        this.loaderVisible = false;
      }
    },
    async sendConfirmationEmail() {
      document.querySelector("body").classList.add("wait");
      this.loaderVisible = true;
      await User.sendEmailConfirmation(this.$root.config, this.user.id);
      document.querySelector("body").classList.remove("wait");
      this.loaderVisible = false;
    },
    async deleteUser() {
      document.querySelector("body").classList.add("wait");
      this.loaderVisible = true;
      try {
        await User.deleteUser(this.$root.config, this.user.id);
        await this.fetchUser(true);
      } catch (e) {
        Sentry.captureException(e);
      }
      document.querySelector("body").classList.remove("wait");
      this.modalVisible = false;
      this.loaderVisible = false;
    },
    getBirthDate,
    getRefer() {
      const result = this.referSentences[this.user.role].filter(el => el.value === this.user.gender);
      return result[0].label;
    },
    miurEmailPlaceholder() {
      return `Se hai una mail nome.cognome@istruzione.it aggiungila ai tuoi dati.
        Ci aiuterai a confermare velocemente il tuo profilo Docente senza dover
        attendere l'intervento di un'agenzia.`;
    },
    openModal(name, payload, isMiurEmail) {
      if (payload && payload.mode) {
        this.emailMode = payload.mode;
        this.emailTarget = payload.mail;
      }
      this.isMiurEmail = isMiurEmail;
      this.componentId = name;
      this.modalVisible = true;
    },
    async updateEmail(email, emailMode) {
      if (emailMode) this.emailMode = emailMode;
      try {
        const payload = {};
        payload.type = this.emailMode === "save" ? "add_email" : "email";
        payload.body = this.emailMode === "save" ? { email } : { old_email: this.emailTarget, new_email: email };
        document.querySelector("body").classList.add("wait");
        this.loaderVisible = true;
        await User.modifyUserEmail(this.$root.config, this.user.id, payload);
        await this.fetchUser(true);
        document.querySelector("body").classList.remove("wait");
      } catch (e) {
        Sentry.captureException(e);
        document.querySelector("body").classList.remove("wait");
      }
      this.modalVisible = false;
      this.loaderVisible = false;
    },
    async updateUser(payload) {
      document.querySelector("body").classList.add("wait");
      this.loaderVisible = true;
      try {
        await User.modifyUserEntities(this.$root.config, this.user.id, payload);
        await this.fetchUser(true);
        document.querySelector("body").classList.remove("wait");
      } catch (e) {
        Sentry.captureException(e);
        document.querySelector("body").classList.remove("wait");
      }
      this.modalVisible = false;
      this.loaderVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$input-wrapper-width: 330px;
$input-height: 40px;

.myhome-user-data {
  @include media("<l") {
    flex-direction: column-reverse;
  }

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: $space-x-large;

  &__right {
    @include media("<=s") {
      margin-right: 0;
    }
    flex-grow: 1;
    margin-right: $space-large;

    .data-field:first-child {
      margin-top: 0;
    }
  }

  &__left {
    @include media("<l") {
      align-items: center;
      display: flex;
      flex-direction: column;
      margin-left: 0;
    }
    margin-left: $space-large;

    &-phrase {
      @include media("<l") {
        text-align: center;
      }
      margin: $space-base 0;

      &-label {
        margin: $space-small 0;
      }

      &-link {
        display: flex;
        flex-direction: row-reverse;

        .data-field__content-link-delete {
          margin-top: $space-base;
        }
      }
    }
  }

  .dea-modal {
    .dea-button {
      margin-top: $space-base;
    }

    .dea-input {
      width: $input-wrapper-width;

      label {
        @include dea-heading-medium-xxs;
      }

      input {
        height: $input-height;
      }
    }
  }
}
</style>
